// extracted by mini-css-extract-plugin
export var downArrow = "_81-0";
export var label = "_81-1";
export var treatmentCard = "_81-3";
export var upArrow = "_81-2";